export enum EBuildingHeatingType {
  Without = 1,
  Central = 2,
  Autonomous = 3,
}
